<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">{{ dynamicTitle }}</div>
        <div>
          <div class="stform">
            <a-form-model ref="realForm" :model="studentInfo">
              <a-row :gutter="16">
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.name_text || '姓名'"
                    :rules="{required: true, message: globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名', trigger: 'blur' }"
                    prop="personName"
                  >
                    <a-input v-model="studentInfo.personName" :disabled="true" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.phone_number || '手机号'"
                    :rules="{required: true, message: globalDataArray.siteTemplateLanguage.please_enter_phone_number || '请输入手机号', trigger: 'blur' }"
                    prop="phoneNumber"
                  >
                    <a-input v-model="studentInfo.phoneNumber" :disabled="true" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.id_card || '身份证号'"
                    :rules="{required: true, message: globalDataArray.siteTemplateLanguage.please_enter_id_card || '请输入身份证号', trigger: 'blur' }"
                    prop="idCard"
                  >
                    <a-input v-model="studentInfo.idCard" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div class="line"></div>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.bank_card_number || '银行卡号'"
                    :rules="getPaymentFieldRules('bankCardNumber')"
                    prop="bankCardNumber"
                  >
                    <a-input v-model="studentInfo.bankCardNumber" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.bank_name || '开户行'"
                    :rules="getPaymentFieldRules('bankName')"
                    prop="bankName"
                  >
                    <a-input v-model="studentInfo.bankName" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.account_name || '账户名'"
                    :rules="getPaymentFieldRules('accountName')"
                    prop="accountName"
                  >
                    <a-input v-model="studentInfo.accountName" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.receiver_phone || '收款人手机号'"
                    :rules="getPaymentFieldRules('receiverPhone')"
                    prop="receiverPhone"
                  >
                    <a-input v-model="studentInfo.receiverPhone" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.receiver_id_card || '收款人身份证号'"
                    :rules="getPaymentFieldRules('receiverIdCard')"
                    prop="receiverIdCard"
                  >
                    <a-input v-model="studentInfo.receiverIdCard" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.upload_attachment || '上传附件'"
                    :rules="getPaymentFieldRules('attachment')"
                    prop="attachment"
                  >
                    <file-upload-new v-model="studentInfo.attachment" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div class="line"></div>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item
                    :label="globalDataArray.siteTemplateLanguage.receiving_address || '收货地址'"
                    :rules="getPaymentFieldRules('deliveryAddress')"
                    prop="deliveryAddress"
                  >
                    <a-input v-model="studentInfo.deliveryAddress" :disabled="isCaptain === 0" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmImpEdit">{{ globalDataArray.siteTemplateLanguage.save || '保存' }}</div>
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel || '取消' }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>
<script>
import FileUploadNew from '@/views/person/component/FileUploadNew.vue'
import { saveOrUpdateUserCompleteInfo, threeVerification } from '@/api/person/person'
import { boolAuth } from '@/api/saiti'
import Cookies from 'js-cookie'

export default {
  name: 'ImproveInfo',
  components: { FileUploadNew },
  computed: {
    currentSystemLanguage() {
      const cookieLang = Cookies.get('DEFAULT_LANG')
      if (cookieLang) return cookieLang
      if (this.globalDataArray?.siteInfo?.language) return this.globalDataArray.siteInfo.language
      return 'zh_CN'
    },
    // 新增：动态标题计算属性
    dynamicTitle() {
      if (this.isTeenagerMode && this.currentMember && this.currentMember.personName) {
        return `${this.globalDataArray.siteTemplateLanguage.improve_information || '完善信息'} - ${this.currentMember.personName}`
      }
      return this.globalDataArray.siteTemplateLanguage.improve_information || '完善信息'
    }
  },
  props: {
    infoPop: {
      type: Boolean,
      default: false
    },
    infoData: {
      type: Object,
      default: () => ({})
    },
    // 新增：青少年模式标识
    isTeenagerMode: {
      type: Boolean,
      default: false
    },
    // 新增：当前选中的团队成员信息
    currentMember: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isCaptain: 0,
      studentInfo: {
        signupId: '',
        id: '',
        userName: '',
        idCard: '',
        bankCard: '',
        // 其他字段也需要在这里定义
        bankCardNumber: '',
        accountName: '',
        phoneNumber: '',
        personName: '',
        receiverIdCard: '',
        deliveryAddress: '',
        attachment: '',
        competitionId: '',
        bankName: '',
        receiverPhone: '',
        sysOrgCode: ''
      },
      verify: {}
    }
  },
  watch: {
    infoData: {
      deep: true,
      immediate: true, // 立即触发一次
      handler(newVal) {
        this.studentInfo.competitionId = newVal.competitionId
        this.studentInfo.personName = newVal?.personName || newVal?.userName || ''
        this.studentInfo.phoneNumber = newVal?.phoneNumber || newVal.userPhone || ''
        this.studentInfo.attachment = newVal.attachment
      }
    }
  },
  mounted() {
  },
  methods: {
    async validate(record) {
      const params = 'language=' + this.globalDataArray.siteInfo.language + '&competitionId=' + record.competitionId
      const boolAuthRes = await boolAuth(params)
      if (boolAuthRes.success) {
        this.verify = boolAuthRes.result
      }
    },
    init(record) {
      console.log('asasa', record)
      this.studentInfo.competitionId = this.infoData.competitionId
      this.studentInfo.id = record.id
      this.studentInfo.personName = this.infoData?.personName || this.infoData?.userName || ''
      this.studentInfo.phoneNumber = this.infoData?.phoneNumber || this.infoData?.userPhone || ''
      this.studentInfo.attachment = this.infoData.attachment
      this.studentInfo.signupId = record.signupId
      this.studentInfo.deliveryAddress = record.deliveryAddress
      this.isCaptain = record.isCaptain
      this.studentInfo.idCard = record.idCard
      this.studentInfo.bankCardNumber = record.bankCardNumber
      this.studentInfo.bankName = record.bankName
      this.studentInfo.accountName = record.accountName
      this.studentInfo.receiverPhone = record.receiverPhone
      this.studentInfo.receiverIdCard = record.receiverIdCard
      this.studentInfo.attachment = record.attachment
      this.studentInfo.sysOrgCode = record.sysOrgCode
      this.validate(record)
    },
    // 获取收款字段验证规则
    getPaymentFieldRules(fieldName) {
      // 队长需要填写收款信息，队员不需要
      if (this.isCaptain === 1) {
        const messages = {
          bankCardNumber: this.globalDataArray.siteTemplateLanguage.please_enter_bank_card_number || '请输入银行卡号',
          bankName: this.globalDataArray.siteTemplateLanguage.please_enter_bank_name || '请输入开户行',
          accountName: this.globalDataArray.siteTemplateLanguage.please_enter_account_name || '请输入账户名',
          receiverPhone: this.globalDataArray.siteTemplateLanguage.please_enter_receiver_phone || '请输入收款人手机号',
          receiverIdCard: this.globalDataArray.siteTemplateLanguage.please_enter_receiver_id_card || '请输入收款人身份证号',
          attachment: this.globalDataArray.siteTemplateLanguage.please_upload_attachment || '请上传附件',
          deliveryAddress: this.globalDataArray.siteTemplateLanguage.please_enter_receiving_address || '请输入收货地址'
        }
        return {
          required: true,
          message: messages[fieldName] || (this.globalDataArray.siteTemplateLanguage.this_field_is_required || '该字段为必填项'),
          trigger: 'blur'
        }
      }
      // 队员不需要验证收款信息，返回undefined确保跳过验证
      return undefined
    },

    confirmImpEdit() {
      console.log(this.studentInfo)
      this.$refs['realForm'].validate(async (err, valid) => {
        if (err) {
          console.log(this.studentInfo, 'this.studentInfo')
          const language = this.globalDataArray?.siteInfo?.language || 'en'
          if (language.includes('zh')) {
            const params = structuredClone(this.studentInfo)
            if (this.verify.boolThree) {
              params.name = params.personName
              params.phone = params.phoneNumber
              params.cardNo = params.idCard
              const res = await threeVerification(params)
              if (!res.success) {
                this.$message.error(res.message)
                return false
              }
            }
          }

          // 准备保存参数
          const params2 = structuredClone(this.studentInfo)

          // 如果是队员，清空收款信息字段，避免覆盖队长的数据
          if (this.isCaptain === 0) {
            params2.bankCardNumber = ''
            params2.bankName = ''
            params2.accountName = ''
            params2.receiverPhone = ''
            params2.receiverIdCard = ''
            params2.attachment = ''
            params2.deliveryAddress = ''
          }

          const res2 = await saveOrUpdateUserCompleteInfo(params2)
          console.log(res2, 'res2')
          if (res2.success) {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.system_save_success_tips || '保存成功')
            this.cancelImpEdit()
            return true
          } else {
            this.cancelImpEdit()
            this.$message.error(res2.message)
            return false
          }
        } else {
          return false
        }
      })
    },
    cancelImpEdit() {
      this.studentInfo = {
        idCard: '',
        bankCard: '',
        bankCardNumber: '',
        accountName: '',
        phoneNumber: '',
        receiverIdCard: '',
        deliveryAddress: '',
        attachment: '',
        personName: '',
        competitionId: '',
        bankName: '',
        receiverPhone: '',
        sysOrgCode: ''
      }
      this.$emit('update:infoPop', false)
      this.$emit('close') // 触发关闭事件，让父组件知道表单已关闭
    }
  }
}
</script>
